<template>
  <el-menu-item
    :index="String('menu_' + item.arme_id + $randomNumber())"
    :key="'menu_' + item.arme_id + $randomNumber()"
  >
    <el-tooltip
      v-if="arpe_id == 1"
      class="item"
      effect="light"
      content="Si está seleccionado, el administrador podrá asignar esta opción a sus usuarios."
      placement="left-start"
    >
      <el-checkbox
        v-model="item.arme_estado"
        :true-label="1"
        :false-label="0"
        @change="handleItemChangeStatus"
      ></el-checkbox>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="light"
      content="Si está seleccionado, el usuario podrá ver esta opción en el menú."
      placement="left-start"
    >
      <el-checkbox
        v-model="item.selected"
        @change="handleItemChange"
      ></el-checkbox>
    </el-tooltip>
    <small>
      {{ item.arme_nombre }}
    </small>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'RecursiveMenuItem',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        arpe_id: localStorage.getItem('profile')
      }
    },
    methods: {
      handleItemChange() {
        this.$emit('item-selected')
      },
      handleItemChangeStatus() {
        this.$emit('item-selected-status')
      }
    }
  }
</script>
